export default __webpack_public_path__ + "static/media/logo-snlc.62328e55.png";